import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.tsx'
import './index.css'

window.addEventListener('error', (event) => {
  console.error('Global error:', event.error)
})

window.addEventListener('unhandledrejection', (event) => {
  console.error('Unhandled promise rejection:', event.reason)
})

const rootElement = document.getElementById("root")

if (!rootElement) {
  console.error('Root element not found')
  document.body.innerHTML = '<div style="padding: 20px; font-family: monospace;">Error: Root element not found. Please check your index.html file.</div>'
} else {
  try {
    createRoot(rootElement).render(
      <BrowserRouter>
        <App />
      </BrowserRouter>
    )
  } catch (error) {
    console.error('Failed to render app:', error)
    rootElement.innerHTML = '<div style="padding: 20px; font-family: monospace;">Error: Failed to render application. Check console for details.</div>'
  }
}
